<template>
  <post-login>
    <template v-slot>
      <v-col :class="{ 'col-sm-10': $route.name !== 'Login' }">
        <router-view :key="$route.fullPath" />
      </v-col>
    </template>
  </post-login>
</template>

<script>
import postLogin from '@layouts/PostLoginLayout.vue';
export default {
  components: {
    postLogin,
  },
};
</script>
